import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LinkSaleoutService } from './services/linkSaleout.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-saleout',
  templateUrl: './linkSaleout.component.html',
  styleUrls: ['./linkSaleout.component.css'],
  providers: [LinkSaleoutService]
})
export class LinkSaleoutComponent implements OnInit {

  @Input() init: number = null;
  public counter: number = 180;
  public isPhone: boolean = true
  public phoneSaleout: string;
  public otpSaleout: string;
  public checkOTP: boolean = false;
  public succesSaleout: boolean = false;
  public checkValidateAccount: any;
  public dataValidateAccount: any;

  constructor(
    public httpClient: HttpClient,
    public linkSaleoutService: LinkSaleoutService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService,
  ) {
  }

  startCoutdowm() {
    if (this.counter > 0) {
      this.doCountdown();
    }
  }

  doCountdown() {
    setTimeout(() => {
      this.counter = this.counter - 1;
      this.processCountdown();
    }, 1000)
  }

  processCountdown() {
    if (this.counter == 0) {
      console.log('count is ', this.counter);
    } else {
      this.doCountdown();
    }
  }

  ngOnInit() {
    this.getData();
  }

  async getData() {
    await this.linkSaleoutService.validateAccountSaleOut().subscribe((res) => {
      console.log('ressss', res)
      if (res.data.items.length == 0) {
        this.checkValidateAccount = false;
      } else {
        const data = res.data.items;
        data.map((val) => {
          if (val.systemType == 0) {
            this.dataValidateAccount = val
          }
        })
      }
      console.log('this.dataValidateAccount', this.dataValidateAccount)
      if (this.dataValidateAccount) {
        this.checkValidateAccount = true;
      }
    })
  }

  checkPhoneSaleout() {
    console.log('TuanBA: ' + this.phoneSaleout)
    if (!this.phoneSaleout) {
      this.toastr.warning(this.translate.instant('SDT_KHONG_DUOC_DE_TRONG'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }

    this.linkSaleoutService.checkPhone(this.phoneSaleout).subscribe((res) => {
      if (res.status === 200) {
        this.checkOTP = true;
        this.isPhone = false;
        this.startCoutdowm();
        if (this.counter == 0) {
          this.counter = 180;
          this.startCoutdowm();
        }
        this.toastr.success(res.data, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
    },
      (error) => {
        this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
          timeOut: 2000,
          positionClass: 'toast-bottom-right',
        });
      }
    );
  }

  verifyOtpSaleout() {
    let body = {
      phone: this.phoneSaleout,
      otp: this.otpSaleout,
      systemType: 0
    }

    if (!body.otp) {
      this.toastr.warning(this.translate.instant('MA_OTP_KHONG_DUOC_DE_TRONG'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (!body.phone) {
      this.toastr.warning(this.translate.instant('SDT_KHONG_DUOC_DE_TRONG'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }

    console.log('tuanday' + body.phone, body.otp)
    this.linkSaleoutService.verifyOTP(body).subscribe((res) => {
      if (res.error == false) {
        this.checkOTP = false;
        this.succesSaleout = true
      } else {
        this.toastr.warning(this.translate.instant('CO_LOI_XAY_RA'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 2000,
        positionClass: 'toast-bottom-right',
      });
    }
    );
  }

  loyalty() {
    window.open(`https://sellout.icheck.vn/portal/auth/login`);
    // this.router.navigateByUrl('/qrcode/integrate-sellout');
    // https://sellout.dev.icheck.vn/portal/auth/login
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/linkSaleout/linkSaleout.component.ts